// ./src/contexts/FormFieldTypesContext/FormFieldTypesContext.tsx
import React, { createContext, useContext } from "react";

import {
  useFormFieldTypes,
  UseFormFieldTypesReturn,
  UseFormFieldTypesOptions,
} from "@/hooks";

export interface FormFieldTypesContextValue extends UseFormFieldTypesReturn {
  // Additional context-specific methods if needed in the future
}

export interface FormFieldTypesProviderProps {
  children: React.ReactNode;
  options?: UseFormFieldTypesOptions;
}

const FormFieldTypesContext = createContext<
  FormFieldTypesContextValue | undefined
>(undefined);

export const FormFieldTypesProvider: React.FC<FormFieldTypesProviderProps> = ({
  children,
  options = {},
}) => {
  const formFieldTypesHook = useFormFieldTypes(options);

  return (
    <FormFieldTypesContext.Provider value={formFieldTypesHook}>
      {children}
    </FormFieldTypesContext.Provider>
  );
};

// Custom hook for using the form field types context
export const useFormFieldTypesContext = (): FormFieldTypesContextValue => {
  const context = useContext(FormFieldTypesContext);

  if (context === undefined) {
    throw new Error(
      "useFormFieldTypesContext must be used within a FormFieldTypesProvider"
    );
  }
  return context;
};
